var React = require('react');

function Amc (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1875_3557)","key":0},React.createElement("path",{"d":"M15.1667 19.761V22.1667H21V24.5H6.99999V22.1667H12.8333V19.761C10.5778 19.4766 8.50361 18.3788 6.99999 16.6737C5.49637 14.9686 4.6667 12.7734 4.66666 10.5V3.5H23.3333V10.5C23.3333 12.7734 22.5036 14.9686 21 16.6737C19.4964 18.3788 17.4222 19.4766 15.1667 19.761ZM1.16666 5.83333H3.49999V10.5H1.16666V5.83333ZM24.5 5.83333H26.8333V10.5H24.5V5.83333Z","fill":"#D64C4C"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1875_3557"},React.createElement("rect",{"width":"28","height":"28","fill":"white"})))]);
}

Amc.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Amc;

Amc.default = Amc;
